const Auth = {
    login        : r => require.ensure([], () => r(require('../components/auth/login_en')),         'auth'),
    register     : r => require.ensure([], () => r(require('../components/auth/register')),         'auth'),
    twofa        : r => require.ensure([], () => r(require('../components/auth/twofa')),         'auth'),
    comingsoon        : r => require.ensure([], () => r(require('../components/auth/comingsoon')),         'auth'),
    registered   : r => require.ensure([], () => r(require('../components/auth/registered')),         'auth'),
    // login_ar     : r => require.ensure([], () => r(require('../components/auth/login_ar')),         'auth'),
}
export default [
    {
        name: 'c.login',
        path: '/c/login',
        component: Auth.login,
        meta: { requiresAuth: false },
    },
    {
        name: 'c.register',
        path: '/c/register',
        component: Auth.register,
        meta: { requiresAuth: false },
    },
    {
        name: 'c.twofa',
        path: '/c/twofa',
        component: Auth.twofa,
        meta: { requiresAuth: false },
    },
    {
        name: 'c.comingsoon',
        path: '/c/comingsoon',
        component: Auth.comingsoon,
        meta: { requiresAuth: false },
    },
    {
        name: 'c.registered',
        path: '/c/registered',
        component: Auth.registered,
        meta: { requiresAuth: false },
    },
    // {
    //     name: 'c.login_ar',
    //     path: '/c/login_ar',
    //     component: Auth.login_ar,
    //     meta: { requiresAuth: false },
    // },
    
]


// WEBPACK FOOTER //
// ./src/app/c/routes/index.js